<template>
	<div class="">
		<div class="ObligeeWrap serviceMain" v-if="tabIdx=='tab1'">
			<div class="searchBar">
				<div class="tittle"> 著作权人管理 </div>
				<div class="rightForm">
					<div>
						<el-button type="primary" @click="clickTab('tab2')">新增个人著作权人</el-button>
						<el-button type="primary" @click="clickTab('tab3')">新增企业著作权人</el-button>
					</div>

					<div>
						<el-input v-model="searchForm.obligeeName" placeholder="请输入名称"></el-input>
						<el-input v-model="searchForm.uniqueCode" placeholder="请输入证件号码"></el-input>
						<el-select v-model="searchForm.obligeeType" clearable placeholder="选择权利人类型" @change="selectObligeeType">
							<el-option label="个人" value="1"></el-option>
							<el-option label="企业" value="2"></el-option>
						</el-select>
						<el-button @click="fetchData">查询</el-button>
					</div>
				</div>
			</div>

			<el-table :data="tableData" :cell-class-name="tabelCellClass" style="width: 100%" v-loading="isLoading">
				<el-table-column label="个人/企业" width="100">
					<template slot-scope="scope">
						<span v-if="scope.row.obligeeType == '1'">个人</span>
						<span v-else-if="scope.row.obligeeType == '2'">企业</span>
					</template>
				</el-table-column>
				<el-table-column label="著作权人">
					<template slot-scope="scope">
						<span v-if="scope.row.obligeeType == '1'">{{scope.row.userName}}</span>
						<span v-else-if="scope.row.obligeeType == '2'">{{scope.row.companyName}}</span>
					</template>
				</el-table-column>
		
				<!-- <el-table-column prop="userName" label="著作权人" width="180">
				</el-table-column> -->
				<el-table-column prop="address" label="地址" max-width="180">
					<template slot-scope="scope">
						<span v-if='scope.row.province == scope.row.city'>{{scope.row.province}}</span>
						<span v-else>{{scope.row.province}}-{{scope.row.city}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="expireDate" :formatter="dateFormatter" label="证件有效期" width="120">
				</el-table-column>
				
				<el-table-column prop="additionalProp1" label="证件照片" min-width="120">
					<template slot-scope="scope">
						<el-image class="img identityPictureImg"
							v-if="scope.row.identityPicture.additionalProp1"
							:src="scope.row.identityPicture.additionalProp1"
							:preview-src-list="[scope.row.identityPicture.additionalProp1]"
						></el-image>
						<el-image class="img identityPictureImg"
							v-if="scope.row.identityPicture.additionalProp2"
							:src="scope.row.identityPicture.additionalProp2"
							:preview-src-list="[scope.row.identityPicture.additionalProp2]"
						></el-image>
						<!-- <el-button type="text" size="small" v-else @click="changeSignature(scope.row)">修改</el-button> -->
					</template>
				</el-table-column>

				<el-table-column prop="signature" label="电子签名/印章"  width="160" min-width="140">
					<template slot-scope="scope">
						<el-image class="img"
							:class="{'el-image2': scope.row.obligeeType == '1'}"
							v-if="scope.row.supportingMaterial.signature"
							:src="scope.row.supportingMaterial.signature"
							:preview-src-list="[scope.row.supportingMaterial.signature]"
						></el-image>
						<el-button type="text" size="small" v-if="!scope.row.supportingMaterial.signature" @click="changeSignature(scope.row.uniqueCode)">添加</el-button>
						<el-button type="text" size="small" v-else @click="changeSignature(scope.row)">修改</el-button>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<!-- <el-button type="text" size="small" @click="toDeleteObligee(scope.row.obligeeCode)">删除</el-button> -->
						<el-tooltip content="实名认证数据不可删除" placement="top" :disabled="!isAuthData(scope.row)">
							<el-button type="text" size="small" @click="toDeleteObligee(scope.row.obligeeCode)" :disabled="isAuthData(scope.row)">删除</el-button>
						</el-tooltip>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next" :total="pagination.total" :current-page.sync="pagination.page"
			 :page-size.sync="pagination.pageSize" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>
		</div>
		<div v-if="tabIdx=='tab2'">
			<add-personal @set-tab-idx="setTabIdx" ></add-personal>
		</div>
		<div v-if="tabIdx=='tab3'">
			<add-company @set-tab-idx="setTabIdx"></add-company>
		</div>

		<!-- 修改签名/印章 弹窗 -->
		<el-dialog
			:visible.sync="showChangeSignature"
			width="460px"
			center
			:title="checkRow.obligeeType==1?'修改电子签名':'修改电子印章'"
			@closed="onCloseChangeSignature"
			>
			<div class="changeSignatureBox">
				<div class="uploadBusinessLicense" >
					<!-- <el-upload class="Uploader"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess"
						:before-upload="uploadBefore" v-loading="loading1">
						<img v-if="form.supportingMaterial.signature" :src="form.supportingMaterial.signature" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload> -->
	<!-- 裁剪图片基本使用 -->
    <upload-cropper
	  :class="checkRow.obligeeType==1?'qianming':'yinzhang'"
      :width="300"
      :height="300"
	  :signature-type="checkRow.obligeeType==1?'qianming':'yinzhang'"
	  @confirm-crop="handleUploadImage"
	  :signature-url="form.supportingMaterial.signature"
    />
					<el-upload class="originalUpload"  :action="uploadUrl"  :headers="uploadHeaders" :show-file-list="false" :on-success="uploadSuccess"
						:before-upload="uploadBefore">
						<el-button type="mini">原图上传</el-button>
					</el-upload>
					<div class="clear"></div>
				</div>
				<div class="blockReminder">
					<div class="description" slot="description">
						{{checkRow.obligeeType == 1 ? '请上传长宽为320*180的等比例PNG图片' : '请上传长宽为150px*150的等比例PNG图片'}}
					</div>
				</div>
				<el-button type="primary" @click="changeSignatureBtn">提交</el-button>
			</div>
		</el-dialog>

	</div>
	
</template>

<script>
	import UploadCropper from '@/components/form/UploadCropper.vue'
	import { mapGetters } from 'vuex'
	import AddCompany from './components/AddCompany'
	import AddPersonal from './components/AddPersonal'
	import {
		queryObligeeList,
		saveOrModify,
		deleteObligee
	} from '@/api/ObligeeService'
	export default {
		name: 'Obligee',
		components: {
			AddCompany,
			AddPersonal,
			UploadCropper,
		},
		data() {
			return {
				tabIdx: 'tab1',
				isLoading: false,
				pagination: {
					page: 1,
					pageSize: 10,
					total:0
				},
				tableData: [],


				uploadUrl: `${process.env.VUE_APP_BASEURL}/v1/ins/file/upload?path=exist/evidence/files/` + Math.random().toString(36).substr(2, 9), // 添加随机数,
				uploadHeaders: {
					'Authorization': this.$store.getters.token,
					'Product-Mode': "READ",
					'Terminal-Code': "IPCHAIN2" + this.$store.getters.terminalCode,
					'Terminal-Type': "WEB",
					'Merchant-Id': "2"
				},
				showChangeSignature: false,
				checkRow: {},
				form: {
					uniqueCode: '',
					supportingMaterial: {
						signature: ''
					},
				},
				searchForm: {
					obligeeName: '',
					obligeeType: '',
					uniqueCode: '',
				},

				loading1: false,
				
			}
		},
		computed: {
			...mapGetters(["mid", "userInfo", "evidencePaymentPrice", "vipInfo","authInfo","obligeeList"]),
		},
		created() {
			this.fetchData();

			let uniqueCode = this.$route.query.uniqueCode;
			// console.log(uniqueCode);
			if(uniqueCode){ // 新登记页面选择著作权人，没有印章，跳转过来的
				this.showChangeSignature = true;
				this.form.uniqueCode = uniqueCode;
			}
			
		},
		methods: {
			setTabIdx(tabIdx) {
				this.tabIdx = tabIdx
			},
			clickTab(tabIdx) {
				// console.log('this.authInfo:',this.authInfo);
				// if(tabIdx != 'tab1' && this.pagination.total <= 0){
				if(tabIdx != 'tab1' && !this.authInfo){
					this.$confirm('您还没有进行实名认证，请先前往个人中心进行实名认证?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						// 用户点击确定时的操作
						this.$router.push('/Mine/RealName');
					}).catch(() => {
						// 用户点击取消时的操作
					});
					return;
				}
				this.tabIdx = tabIdx
			},
			 // 日期格式化
			dateFormatter (row, column) {
				if(row.longValid==1){
					return this.dayjs(row.startDate*1000).format("YYYY-MM-DD") + `
					长期有效`;
				}else{
					return this.dayjs(row.startDate*1000).format("YYYY-MM-DD") + `
					` + this.dayjs(row.expireDate*1000).format("YYYY-MM-DD")
				}
			},
			onTabelRowClick(row) {
			},
			tabelCellClass({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				if (column.property == 'certificate') {
					return 'certificateCell'
				}
			},
			fetchData() {
				this.isLoading = true
				let that = this;
				queryObligeeList(this.pagination.page, this.pagination.pageSize, this.searchForm).then(({ data }) => {
					// console.log("著作权人接口数据",data);
					that.tableData = data.list;
					that.pagination.total = data.total/1;
					this.isLoading = false
				});
			},
			sizeChange(pageSize) {
				this.pagination.pageSize = pageSize;
				this.pagination.page = 1;
				this.fetchData()
			},
			currentChange(pageNum) {
				this.pagination.page = pageNum;
				// 更新表格数据
				this.fetchData()
			},

			// 删除权利人
			toDeleteObligee(obligeeCode){
				this.$confirm('确定删除该权利人吗?', '温馨提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					deleteObligee(obligeeCode).then(({ data }) => {
						// if(data > 0){
							this.$message.success('删除成功!');
							this.fetchData();
						// }
					})
				}).catch(() => {
					// 用户点击取消时的操作
				});
			},

			//  修改印章
			changeSignature(row){
				// console.log(row);
				this.showChangeSignature = true;
				this.form.uniqueCode = row.uniqueCode;
				this.checkRow = row;
			},

			onCloseChangeSignature(){
				this.showChangeSignature = false;
			},
			uploadSuccess(res, file) {
				if(!res.downloadUrl){
					this.$message.error('上传失败！');
					return false
				}
				this.form.supportingMaterial.signature = res.downloadUrl;
				this.loading1 = false;
			},
			uploadBefore(file) {
				// console.log(file);
				// 电子印章只能是png格式
				const isImage = file.type === 'image/png'; 
				const isLt2M = file.size / 1024 / 1024 < 5;
				this.loading1 = true;
				if (!isImage) {
					this.$message.error('上传图片只能是 PNG 格式!');
					this.loading1 = false;
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 5MB!');
					this.loading1 = false;
				}
				return isImage && isLt2M;
			},
			changeSignatureBtn(){
				if(this.form.supportingMaterial.signature == ''){
					this.$message.error('请先上传电子签名/印章!');
					return false;
				}
				saveOrModify(this.form).then(({ data }) => {
					// console.log(data);
					if(data > 0){ // 大于0就修改成功，这个返回是当前记录的ID
						// console.log('修改成功');
						this.$message.success('修改成功!');
						this.showChangeSignature = false;
						this.form.supportingMaterial.signature = '';
						this.fetchData();
					}
				})
			},
	// 调用组件函数
	handleUploadImage(data) {
		//   console.log('开始上传图片:', file)
		// 创建 FormData
		const formData = new FormData()
		formData.append('file', data.file)
		// 使用 Fetch API 发送请求
		fetch(this.uploadUrl, {
			method: 'POST',
			headers: this.uploadHeaders,
			body: formData,
		}).then(res => res.json()).then(res => {
			// console.log('上传成功，返回数据:', res)
			// this.$message.success('上传成功！')
			this.form.supportingMaterial.signature = res.downloadUrl;
		}).catch(error => {
			this.$message.error('上传失败：' + error.message)
			throw error
		})
    },

		
			//  选择类型-查询列表
			selectObligeeType(val){
				if(val === '' || val === null || val.length === 0){
					// console.log('选择已被清空'); // 执行其他逻辑...
					this.searchForm.obligeeType = null;
				}else{
					this.searchForm.obligeeType = val;
				}
			},


			// 判断著作权人列表里面，是否有实名认证数据，并且判断为不可删除对象
			isAuthData(row) {
				// console.log('row--',row);
				// console.log('this.authInfo--',this.authInfo);
				return this.authInfo && row.uniqueCode === this.authInfo.uniqueCode;
			},

		}
	}
</script>

<style lang='scss' scoped>
	@import '../../../assets/css/mine.scss';
	/deep/.searchBar{align-items: flex-start;}
	/deep/.searchBar .tittle{min-width: 80px;}
	/deep/.el-date-editor{width: 180px!important;}
	/deep/.searchBar .rightForm div{display: flex;align-items: center;}
	/deep/.searchBar .rightForm div:first-child{justify-content: flex-end;}
	/deep/.searchBar .rightForm {display: flex;flex-direction: column;gap: 16px; /* 控制两行之间的间距 */}
	/deep/.searchBar .rightForm .el-button{margin-left: 16px;}
	/deep/.searchBar .rightForm .el-input{margin-left: 16px;}

	/deep/.cell{
		display: flex;
		align-items: center;
	}
	/deep/.el-image{
		display: flex;
		align-items: center;
		img{width: 50px;height: 50px;margin-right: 8px;}
	}
	/deep/.el-image2{
		img{width: 89px;height: 50px;margin-right: 8px;}
	}
	/deep/.el-table td.el-table__cell div{
		white-space: pre-line;
	}

	/deep/.identityPictureImg{
		display: contents;
		width: auto;
	}
	/deep/.identityPictureImg img{
		width: auto!important;
	}

.searchBar .tittle{min-width: 120px;}

	.changeSignatureBox{
		.uploadBusinessLicense {
			.Uploader {
				width: 132px;
				height: 132px;
				background: #F9FAFC;
				border-radius: 4px;
				border: 1px solid #C0CCDA;
				position: relative;
				margin: 0 auto;
			}
			/deep/.el-upload{
				width: 100%;
			}

			.Uploader:hover {
				border-color: #007DFF;
			}
			
			.Uploader img{
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}

			.avatar-uploader-icon {
				font-size: 28px;
				color: #8c939d;
				text-align: center;
				line-height: 130px;
			}

			.avatar {
				width: auto;
				max-width: 100%;
				height: auto;
				max-height: 100%;
				display: block;
				position: absolute;
				top:50%; 
				left:50%;
				transform: translate(-50%,-50%);
			}
			
		}

		.blockReminder {
			background: rgba(255, 231, 186, 0.2);
			border: 1px solid #FFD591;
			padding: 16px;
			width: 100%;
			margin-top: 8px;
			line-height: 1.5;
			.description {
				font-size: 12px;
				font-weight: 400;
				color: rgba(0, 18, 22, 0.5);
			}
		}
		button{
			width: 120px;
			display: block;
			margin: 20px auto;
		}
	}

	.upload-cropper{
		display: block;
		width: 132px;
		margin: 0 auto;
	}
	.qianming{
		width: 180px;
	}

	.uploadBusinessLicense{position: relative;height: 132px;}
	.originalUpload{position: absolute;right: 0;bottom: 0;}
	.originalUpload button{display: block;margin: 0;width: 100px;}

</style>
